module.exports = __webpack_public_path__ + "img/40_38_065_000.9626f46a.jpg";